import { AxiosRequestConfig } from "axios";
import { ITeamUsageItemsCsv, ITeamUsageItemsRequest } from "./teams.type";

// REF-6975: axios `transformResponse` for GET teams/usage-report/items.csv. HttpClient.get hands
// back only the body, so the CORS-exposed `X-Truncated` header (true when the row cap was hit —
// 1,000 rows for trial viewers, 10,000 otherwise) is folded into it here. axios 0.26 passes lowercased plain-object headers. Anything that
// is not a Blob body passes through untouched.
export const foldUsageCsvResponse = (data: unknown, headers?: Record<string, string>): ITeamUsageItemsCsv | unknown =>
  data instanceof Blob ? { file: data, truncated: String(headers?.["x-truncated"] ?? "").toLowerCase() === "true" } : data;

// The request config for that call. HttpClient's response interceptor and `get()` only ever see
// `response.data`, so the header must be read HERE, inside axios's transform step — which runs on the
// raw response (data + headers) before either. Pinned end-to-end through the real HttpClient by
// usageCsv.test.ts.
export const usageCsvRequestConfig = (params: Omit<ITeamUsageItemsRequest, "page" | "page_size">): AxiosRequestConfig => ({
  params,
  responseType: "blob",
  transformResponse: foldUsageCsvResponse,
});
